import { useContext } from 'react'

import { PermissionsCatalogContext } from '../context'

export const usePermissionsCatalog = () => useContext(PermissionsCatalogContext)
